import Link from 'next/link';
import styled from 'styled-components';

import COLORS from 'styles/colors';
import { weight } from 'styles/typography';

const A = styled.a`
  font: inherit;
  font-weight: ${weight.semibold};
  color: ${COLORS.dawn};
  text-decoration: underline;
`;

const LinkStyled = ({ href, targetBlank, children, className, ...props }) => {
  return (
    <>
      {href ? (
        <Link href={href} passHref {...props}>
          <A
            target={targetBlank ? '_blank' : '_self'}
            rel="noreferrer"
            className={className}
          >
            {children}
          </A>
        </Link>
      ) : (
        <A as="button" className={className} {...props}>
          {children}
        </A>
      )}
    </>
  );
};

export default LinkStyled;
